module.exports = __webpack_public_path__ + "img/21.2a7f2f71.png";